/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// 👇 SSR guard
const isBrowser = typeof window !== 'undefined';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

if (isBrowser) {

  // ===== Service Worker Cleanup =====
  if ('serviceWorker' in navigator && !localStorage.getItem('sw-updated')) {

    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        for (const registration of registrations) {
          registration.unregister();
        }
      })
      .then(() => {
        localStorage.setItem('sw-updated', 'true');
      });
  }

  // ===== Clear flag after load =====
  window.addEventListener('load', () => {
    setTimeout(() => {
      localStorage.removeItem('sw-updated');
    }, 10000);
  });

}
